import { css } from 'styled-components';
// to style UiMarkdown and UiTextBlock consistently
export function getTextSizeCSS(textSize) {
    return (textSize &&
        (textSize === 'Large'
            ? css `
          font-size: ${fontSizes.lg};
          line-height: 1.75;
        `
            : css `
          font-size: ${fontSizes.sm};
        `));
}
// base rem size is 16px, trello sets `md` in the body
export const fontSizes = {
    xxs: '0.75rem',
    xs: '0.875rem',
    sm: '1rem',
    md: '1.25rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '2.25rem' // 36px
};
//# sourceMappingURL=textSize.js.map